// @ts-strict-ignore
import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSnackBar } from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import apiCalls from '~/helpers/apiCalls';

const {
  entities: { getEntity },
  portfolioEvaluations: { evaluationDetails, entityDetail },
} = apiCalls;

export const usePortfolioEvaluationDetails = ({
  portfolioEvaluationToken,
  page,
  paginateBy,
  q,
}) => {
  const addSnackBar = useSnackBar();
  const { typhonDomain } = useContext(UserContext);

  return useQuery({
    queryKey: ['portfolio-evaluation-details', portfolioEvaluationToken, page, paginateBy, q],
    queryFn: async () => {
      const data = await evaluationDetails({
        typhonDomain,
        portfolioEvaluationToken,
        page,
        paginateBy,
        q,
      });

      return data;
    },
    keepPreviousData: true,
    onError: () => {
      addSnackBar({ title: 'Error loading Portfolio Evaluation details', type: 'danger' });
    },
  });
};

export const useEntityPortfolioEvaluation = ({ entityToken, portfolioEvaluationToken }) => {
  const { typhonDomain } = useContext(UserContext);

  return useQuery({
    queryKey: ['entity-portfolio-evaluation', entityToken, portfolioEvaluationToken],
    queryFn: async () => {
      const data = await evaluationDetails({
        typhonDomain,
        portfolioEvaluationToken,
        page: 1,
        paginateBy: 1,
        q: {
          entity_tokens: [entityToken],
        },
      });

      return data;
    },
  });
};

export const useEntityPortfolioEvaluationTags = ({ entityToken, portfolioEvaluationToken }) => {
  const { typhonDomain } = useContext(UserContext);

  return useQuery({
    queryKey: ['entity-portfolio-evaluation-tags', entityToken, portfolioEvaluationToken],
    queryFn: async () => {
      const { tags: tagData } = await entityDetail({
        dimensions: [],
        entityToken,
        portfolioEvaluationToken,
        typhonDomain,
      });
      const triggeredTags = tagData.filter(tag => !!(tag.is_set));

      return triggeredTags;
    },
  });
};

export const useEntity = ({ entityToken }) => useQuery({
  queryKey: ['entity-portfolio-evaluation', entityToken],
  queryFn: async () => {
    const { entity: data } = await getEntity({ entityToken });

    return data;
  },
  enabled: Boolean(entityToken),
});
